module.exports = __webpack_public_path__ + "static/media/compass-north.27dca9fd.png";